// features/auth/authApiSlice.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../components/Constant";

export const authApiSlice = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    checkLogin: builder.mutation({
      query: (credentials) => ({
        url: "/check_login",
        method: "POST",
        body: {
          countryCode: credentials.countryCode.replace("+", ""),
          phoneNumber: credentials.phoneNumber,
          password: credentials.password,
        },
      }),
    }),
    checkReporterLogin: builder.mutation({
      query: (credentials) => ({
        url: "/check_reporter_login", // Assuming the API for reporter login is different
        method: "POST",
        body: {
          countryCode: credentials.countryCode.replace("+", ""),
          phoneNumber: credentials.phoneNumber,
          password: credentials.password,
        },
      }),
    }),
    createOtp: builder.mutation({
      query: (phoneData) => ({
        url: "/otp_creation",
        method: "POST",
        body: {
          countryCode: phoneData.countryCode.replace("+", ""),
          phone: phoneData.phoneNumber,
        },
      }),
    }),
    // In crmAdminApiSlice.js
    verifyOtp: builder.mutation({
      query: (otpData) => ({
        url: "/otp_verification",
        method: "POST",
        body: otpData,
      }),
      transformResponse: (response) => {
        if (response.success) {
          return {
            success: true,
            token: response.token, // Ensure backend sends this
            user: response.user, // And user data if available
          };
        }
        return response;
      },
    }),
  }),
});

export const {
  useCheckLoginMutation,
  useCheckReporterLoginMutation,
  useCreateOtpMutation,
  useVerifyOtpMutation,
} = authApiSlice;
